/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Autobahnen`
};

const en_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Motorways`
};

const es_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Autopistas`
};

const fr_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Autoroutes`
};

const it_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Autostrade`
};

const nl_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Snelwegen`
};

const pt_highways = /** @type {(inputs: {}) => string} */ () => {
	return `Autoestradas`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const highways = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.highways(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("highways", locale)
	if (locale === "de") return de_highways(inputs)
	if (locale === "en") return en_highways(inputs)
	if (locale === "es") return es_highways(inputs)
	if (locale === "fr") return fr_highways(inputs)
	if (locale === "it") return it_highways(inputs)
	if (locale === "nl") return nl_highways(inputs)
	return pt_highways(inputs)
};